import React from 'react';
import { KeyField } from './ProviderToggle';

export const ApiKeyTabView: React.FC<{
  polloKey: string; setPolloKey: (v: string) => void;
  runningHubKey: string; setRunningHubKey: (v: string) => void;
  grsaiKey: string; setGrsaiKey: (v: string) => void;
  falKey: string; setFalKey: (v: string) => void;
  agnesKey: string; setAgnesKey: (v: string) => void;
}> = ({ polloKey, setPolloKey, runningHubKey, setRunningHubKey, grsaiKey, setGrsaiKey, falKey, setFalKey, agnesKey, setAgnesKey }) => (
  <div className="p-6 space-y-6">
    <KeyField
      label="Pollo.ai API Key (Wan 2.5)"
      value={polloKey} onChange={setPolloKey}
      placeholder="粘贴您的 Pollo API Key..."
      description={<>用于激活 <strong>Wan 2.1 / Wan 2.5</strong> 视频生成模型。密钥仅保存在您的浏览器本地存储中，不会上传至 BONG · AI 服务器。</>}
      provider="gemini" providerLabel="Gemini"
      linkHref="https://pollo.ai/dashboard/api-keys" linkText="获取 Key"
      prefix="key-" showBorder={false}
    />
    <KeyField
      label="RunningHub API Key (全能图片PRO)"
      value={runningHubKey} onChange={setRunningHubKey}
      placeholder="粘贴您的 RunningHub API Key..."
      description={<>用于激活 <strong>全能图片PRO</strong> 文生图/图生图模型。密钥仅保存在您的浏览器本地存储中，不会上传至 BONG · AI 服务器。</>}
      provider="runninghub" providerLabel="RunningHub"
      linkHref="https://www.runninghub.cn" linkText="获取 Key"
    />
    <KeyField
      label="GRS AI API Key (GPT Image 2)"
      value={grsaiKey} onChange={setGrsaiKey}
      placeholder="粘贴您的 GRS AI API Key..."
      description={<>用于激活 <strong>GPT Image 2</strong> 文生图/图生图模型。密钥仅保存在您的浏览器本地存储中，不会上传至 BONG · AI 服务器。</>}
      provider="grsai" providerLabel="GRS AI"
      linkHref="https://grsai.ai/" linkText="获取 Key"
    />
    <KeyField
      label="fal.ai API Key (Kling 3.0)"
      value={falKey} onChange={setFalKey}
      placeholder="粘贴您的 fal.ai API Key..."
      description={<>用于激活 <strong>Kling 3.0</strong> 视频生成模型（标准版/专业版）。密钥仅保存在您的浏览器本地存储中，不会上传至 BONG · AI 服务器。</>}
      provider="falai" providerLabel="fal.ai"
      linkHref="https://fal.ai/dashboard/keys" linkText="获取 Key"
    />
    <KeyField
      label="Agnes API Key (Agnes 2.0 Flash)"
      value={agnesKey} onChange={setAgnesKey}
      placeholder="粘贴您的 Agnes API Key..."
      description={<>用于激活 <strong>Agnes 2.0 Flash</strong> 对话、<strong>Agnes Image 2.1 Flash</strong> 图片生成和 <strong>Agnes Video V2.0</strong> 视频生成模型。密钥仅保存在您的浏览器本地存储中，不会上传至 BONG · AI 服务器。</>}
      provider="agnes" providerLabel="Agnes"
      linkHref="https://agnes-ai.com" linkText="获取 Key"
    />
  </div>
);
